<template>
	<div class="container">
		<div class="content">
			<div class="contacts d_flex">
				<!-- 유저 리스트 -->
				<div class="friends_list_wrap">
					<span class="icon PLUS"></span>
					<div class="profile">
						<span class="user_photo AVATAR mb_20"></span>
						<p class="mb_20">아이디</p>
						<div class="search_area">
							<input type="text" placeholder="검색" />
							<a class="search_icon SEARCH"></a>
						</div>
					</div>
					<div class="list_area mt_20">
						<ul class="d_flex tab_area">
							<li :class="{ active: showTab === 1 }">
								<router-link @click="selectTab(1)" to>즐겨찾기</router-link>
							</li>
							<li :class="{ active: showTab === 2 }">
								<router-link @click="selectTab(2)" to>연락처</router-link>
							</li>
						</ul>
						<div class="tab_content mt_15">
							<div v-if="showTab === 1">
								<ul class="friends_list">
									<li class="selected">
										<router-link to>
											<p class="friend_name">홍길동</p>
											<p class="account_number">12345-678-901234</p>
										</router-link>
										<!--										<input type="checkbox" class="checkbox_star" checked />-->
										<!--										bookmarked 클래스로 별 색상 제어-->
										<span class="STAR bookmarked"></span>
									</li>
									<li>
										<router-link to>
											<p class="friend_name">이름</p>
											<p class="account_number">12345-678-901234</p>
										</router-link>
										<span class="STAR bookmarked"></span>
									</li>
									<li>
										<router-link to>
											<p class="friend_name">이름</p>
											<p class="account_number">12345-678-901234</p>
										</router-link>
										<span class="STAR bookmarked"></span>
									</li>
									<li>
										<router-link to>
											<p class="friend_name">이름</p>
											<p class="account_number">12345-678-901234</p>
										</router-link>
										<span class="STAR bookmarked"></span>
									</li>
									<li>
										<router-link to>
											<p class="friend_name">이름</p>
											<p class="account_number">12345-678-901234</p>
										</router-link>
										<span class="STAR bookmarked"></span>
									</li>
									<li>
										<router-link to>
											<p class="friend_name">이름</p>
											<p class="account_number">12345-678-901234</p>
										</router-link>
										<span class="STAR bookmarked"></span>
									</li>
									<li>
										<router-link to>
											<p class="friend_name">이름</p>
											<p class="account_number">12345-678-901234</p>
										</router-link>
										<span class="STAR bookmarked"></span>
									</li>
									<li>
										<router-link to>
											<p class="friend_name">이름</p>
											<p class="account_number">12345-678-901234</p>
										</router-link>
										<span class="STAR bookmarked"></span>
									</li>
								</ul>
							</div>

							<div v-if="showTab === 2">친구없음</div>
						</div>
					</div>
				</div>
				<!-- 유저 정보 영역 -->
				<ContactsInfoTab></ContactsInfoTab>
			</div>
		</div>
	</div>
</template>

<script>
import ContactsInfoTab from '@/components/User/Pay/ContactsInfoTab';
export default {
	name: 'Contacts',
	components: {
		ContactsInfoTab,
	},
	data() {
		return {
			showTab: 1,
		};
	},
	methods: {
		selectTab(e) {
			this.showTab = e;
		},
	},
};
</script>
